<template>
  <div :class="inputCssClass">
    <v-autocomplete
      solo
      :error-messages="error"
      v-bind="$attrs"
      :loading="loading"
      v-model="selected"
      :search-input.sync="search"
      clearable
      :items="items"
      :label="$t(label)"
      :multiple="multiple"
      chips
      :item-text="itemText"
      @input="onSelected"
      :item-value="itemValue"
    ></v-autocomplete>
  </div>
</template>

<script>
// import apiCtrl from '@/services/aru-services/aru-api.service.js';
import apiCtrl from '@/services/aru-services/aru-api.service.js';
// import AruSelectListMixin from '@/mixins/list/AruSelectListMixin.js';
import AruSearchMixin from '@/mixins/search/AruSearchMixin.js';

export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  mixins: [AruSearchMixin],

  props: {
    entity: String,
    value: Array,
    timeout: {
      type: Number,
      default: 500,
    },
    minLength: {
      type: Number,
      default: 3,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    inputCssClass: {
      type: [Object, String],
    },
    label: {
      type: String,
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      params: {
        search: '',
      },
      search: '',
      selected: this.value ? this.value : this.multiple ? [] : null,
    };
  },

  mounted() {
    this.getEntities();
  },
  methods: {
    getEntities() {
      this.loading = true;
      this.$emit('loading');
      let config = {};
      config.params = this.params;
      apiCtrl.get('/' + this.entity, config).then(res => {
        // Los listados paginados envuelven la lista en `data`; los input-select devuelven el array.
        this.items = Array.isArray(res.data) ? res.data : res.data.data;
        this.loading = false;
        if (res.data.hasOwnProperty('meta')) {
          this.$emit('meta', res.data.meta);
        }
      });
    },
    searchIfStop: function(val) {
      if (val === this.search) {
        this.getEntities();
      }
    },
    onSelected() {
      this.$emit('input', this.selected);
    },
  },
  // watch: {
  //     search: function (val, oldVal) {
  //         this.params.search = val;
  //         if (!this.loading && !!val && (val.length > this.minLength || (!!oldVal && oldVal.length > val.length))) {

  //             // console.log(val);
  //             const component = this;
  //             setTimeout(() => {
  //                 component.searchIfStop(val)
  //             }, component.timeout)

  //         }

  //     },
  //     value: function (val, oldVal) {
  //         console.log({
  //             valueChange: val
  //         });
  //     }
  // }
};
</script>

<style></style>
